var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8513 0.0945382C11.0672 0.219784 11.2 0.450446 11.2 0.699975V3.49998C12.0293 3.49998 12.7752 3.86142 13.2869 4.43314C13.7298 4.92804 14 5.58329 14 6.29997C14 7.01666 13.7298 7.67191 13.2869 8.16681C12.7752 8.73853 12.0293 9.09997 11.2 9.09997V11.9C11.2 12.1495 11.0672 12.3802 10.8513 12.5054C10.6355 12.6307 10.3694 12.6315 10.1527 12.5077L5.6 9.9062V13.3C5.6 13.6866 5.2866 14 4.9 14H2.1C1.7134 14 1.4 13.6866 1.4 13.3V9.79998C0.626801 9.79998 0 9.17317 0 8.39997V4.19998C0 3.42678 0.626801 2.79998 1.4 2.79998H5.4141L10.1527 0.092205C10.3694 -0.0315962 10.6355 -0.0307072 10.8513 0.0945382ZM5.6 8.39997C5.72182 8.39997 5.84153 8.43177 5.9473 8.4922L9.8 10.6937V1.9062L5.9473 4.10775C5.84153 4.16818 5.72182 4.19998 5.6 4.19998H1.4V8.39997H5.6ZM2.8 9.79998V12.6H4.2V9.79998H2.8ZM11.2 7.69998C11.6146 7.69998 11.9863 7.52067 12.2437 7.23314C12.4658 6.98498 12.6 6.65899 12.6 6.29997C12.6 5.94096 12.4658 5.61497 12.2437 5.36682C11.9863 5.07928 11.6146 4.89998 11.2 4.89998V7.69998Z",
    fill: "#C8CACB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.86c6fd1edb01d1cfa72a13a68d814d92.svg";
export { ForwardRef as ReactComponent };